/** @jsx h */
import { h } from 'preact'
import TagLine from '../TagLine'

const Footer = ({ onAboutClick, showPoweredByProvenanceModal, children }) =>
  <footer>
    <div class='ModalCard-footer'>
      {children && <div class='u-marginTop16'>{children}</div>}
      <div class='u-marginTop16'>
        <TagLine
          onAboutClick={onAboutClick}
          showPoweredByProvenanceModal={showPoweredByProvenanceModal}
        />
      </div>
    </div>
    <div class='ClaimCard-footer--evidence' />
  </footer>

export default Footer
